import {
  getUpgradeAssessment,
  getUpgradePlan,
  getUpgradeTemplate,
} from 'api/frontend';
import {
  getUpgradeModeHumanReadable,
  UpgradeViewMode,
} from './UpgradesHelpers';
import * as Sentry from '@sentry/browser';
import { OptionsObject, SnackbarMessage, SnackbarKey } from 'notistack';
import { somethingWentWrong, toastAutoHideDuration } from 'constants/toasts';
import { UpgradeExportFormat } from 'api/models';
import {
  isExampleData,
  UPGRADE_ASSESSMENTS,
  UPGRADE_TEMPLATES,
  UPGRADES,
} from 'src/data/upgrades';

export async function openUpgradeExportInNewWindow(
  mode: UpgradeViewMode,
  id: string,
  token: string,
  enqueueSnackbar: (
    message: SnackbarMessage,
    options: OptionsObject,
  ) => SnackbarKey,
) {
  let exportUrl: string = '';

  try {
    switch (mode) {
      case UpgradeViewMode.Plan: {
        if (isExampleData(id)) {
          exportUrl =
            UPGRADES.find((up) => up.id === id)?.exports?.find(
              (e) => e.format == UpgradeExportFormat.markdown,
            )?.url || '';
        } else {
          const response = await getUpgradePlan(id, {
            headers: { Authorization: `Bearer ${token}` },
          });
          exportUrl =
            response.exports?.find(
              (e) => e.format == UpgradeExportFormat.markdown,
            )?.url || '';
        }
        break;
      }
      case UpgradeViewMode.Template: {
        if (isExampleData(id)) {
          exportUrl =
            UPGRADE_TEMPLATES.find((ut) => ut.id === id)?.exports?.find(
              (e) => e.format == UpgradeExportFormat.markdown,
            )?.url || '';
        } else {
          const response = await getUpgradeTemplate(id, {
            headers: { Authorization: `Bearer ${token}` },
          });
          exportUrl =
            response.exports?.find(
              (e) => e.format == UpgradeExportFormat.markdown,
            )?.url || '';
        }
        break;
      }

      case UpgradeViewMode.Assessment: {
        if (isExampleData(id)) {
          exportUrl =
            UPGRADE_ASSESSMENTS.find((ua) => ua.id === id)?.exports?.find(
              (e) => e.format == UpgradeExportFormat.markdown,
            )?.url || '';
        } else {
          const response = await getUpgradeAssessment(id, {
            headers: { Authorization: `Bearer ${token}` },
          });
          exportUrl =
            response.exports?.find(
              (e) => e.format == UpgradeExportFormat.markdown,
            )?.url || '';
        }
        break;
      }
    }
    if (exportUrl === '') {
      throw new Error(`no markdown export url found for ${mode} ${id}`);
    } else {
      window.open(exportUrl, '_blank', 'noopener,noreferrer');
    }
  } catch (error) {
    Sentry.captureException(error);
    enqueueSnackbar(
      somethingWentWrong.replace(
        '<action>',
        `exporting the ${getUpgradeModeHumanReadable(mode)} as Markdown`,
      ),
      {
        variant: 'error',
        autoHideDuration: toastAutoHideDuration,
      },
    );
  }
}
